import React, { Component } from 'react';
import { Accordion, Grid, Icon, Header } from 'semantic-ui-react';
import AddLesson from "./AddLesson";
import ContactList from "./ContactList";
import AddPreReqProgram from './AddPreReqProgram';
import AddYearOneProgram from './AddYearOneProgram';
import AddYearTwoProgram from './AddYearTwoProgram';
import AddTafsir from './AddTafsir';
import AddTajweed from './AddTajweed';


class AdminAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: -1
    };
  }

  handleClick = (index) => {
    index !== this.state.activeIndex ? this.setState({ activeIndex: index }) : this.setState({ activeIndex: -1 });
  }

  render() {
    return (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Accordion fluid styled>
                <Accordion.Title active={this.state.activeIndex === 0} onClick={() => this.handleClick(0)}>
                  <Icon name='dropdown' />
                  Lessons
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 0}>
                  <Header as="h5" content="Add Lesson" />
                  <AddLesson />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 1} onClick={() => this.handleClick(1)}>
                  <Icon name='dropdown' />
                  Pre Req Program
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 1}>
                  <Header as="h5" content="Add Program" />
                  <AddPreReqProgram />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 2} onClick={() => this.handleClick(2)}>
                  <Icon name='dropdown' />
                  Year 1 Program
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 2}>
                  <Header as="h5" content="Add Program" />
                  <AddYearOneProgram />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 3} onClick={() => this.handleClick(3)}>
                  <Icon name='dropdown' />
                  Year 2 Program
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 3}>
                  <Header as="h5" content="Add Program" />
                  <AddYearTwoProgram />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 4} onClick={() => this.handleClick(4)}>
                  <Icon name='dropdown' />
                  Tafsir
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 4}>
                  <Header as="h5" content="Add Tafsir" />
                  <AddTafsir />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 5} onClick={() => this.handleClick(5)}>
                  <Icon name='dropdown' />
                  Tajweed
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 5}>
                  <Header as="h5" content="Add Tajweed" />
                  <AddTajweed />
                </Accordion.Content>
                <Accordion.Title active={this.state.activeIndex === 6} onClick={() => this.handleClick(6)}>
                  <Icon name='dropdown' />
                    Contact
                </Accordion.Title>
                <Accordion.Content active={this.state.activeIndex === 6}>
                  <Header as="h5" content="Remove Comment" />
                  <ContactList />
                </Accordion.Content>
              </Accordion>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default AdminAccordion;